import { lazy } from 'react';

export const AccountsBeginJourneyScreenLazy = lazy(async () => {
  const { AccountsBeginJourneyScreen } = await import('./accounts-begin-journey.screen.tsx');
  return { default: AccountsBeginJourneyScreen };
});
